import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';
import Button from '../../../../core/modules/common/components/Button';
import { renderTextField } from '../../../../core/modules/common/tools/FormTools';
import themeStyles from '../../../../materialUiTheme';

const EditSelectionForm = (props) => {
  const {
    handleSubmit,
    errorMessage,
    onCloseModal,
    field,
    name,
  } = props;

  let translatedErrorMessage;
  if (errorMessage) translatedErrorMessage = <FormattedMessage id={errorMessage} />;

  return (
    <form onSubmit={handleSubmit} className="operator-form">
      <FormattedMessage id={`app.save.selection.form.${field}`}>
        {txt => (
          <Field
            label={name || txt}
            name={field}
            component={renderTextField}
            autoComplete="off"
          />
        )}
      </FormattedMessage>
      <p className="error-message">
        {translatedErrorMessage}
      </p>
      <div className="button-container">
        <Button text="app.button.cancel" onClick={onCloseModal} />
        <Button
          type="submit"
          text="app.button.save"
          style={themeStyles.blueButton}
        />
      </div>
    </form>
  );
};

EditSelectionForm.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  field: PropTypes.string,
  name: PropTypes.string,
};

EditSelectionForm.defaultProps = {
  errorMessage: '',
  field: 'name',
};

export default EditSelectionForm;
